import React from 'react';
import CrossDeptTaskDetailPage from '../CrossDeptTaskDetailPage';

const PortalCrossDeptTaskDetailPage = () => (
  <CrossDeptTaskDetailPage portal={true} />
);

export default PortalCrossDeptTaskDetailPage;
